import { FC } from 'react';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import styles from './Home.module.css';

type MapHeaderProps = {
    title: string;
    subtitle: string;
    description: string;
};

export const MapHeader: FC<MapHeaderProps> = ({ title, subtitle, description }) => (
  <div className={styles.mapHeader}>
    <Typography tagVariant={TypographyTagVariants.span} classes={styles.mapLabel}>
      {subtitle}
    </Typography>
    <Typography tagVariant={TypographyTagVariants.h2} classes={styles.mapTitle}>
      {title}
    </Typography>
    <Typography classes={styles.mapSubtitle}>
      {description}
    </Typography>
  </div>
);